import { css } from "@emotion/react";

type Alignment = "center" | "start" | "end";

export const container = (alignment: Alignment) => css`
  padding: 0 auto;
  display: flex;
  justify-content: ${alignment};
`;

export const content = css`
  max-width: 700px;
`;
